export class SaleConfig {
  prefixReceipt: string = 'REC/{year}/';
  textReceiptHeader: string = '';
  textReceiptFooter: string = '';

  prefixInvoice: string = 'INV/{year}/';
  textInvoiceHeader: string = '';
  textInvoiceFooter: string = '';
  paymentTermsDays: number[] = [7, 15, 30, 45, 60, 90];

  prefixQuote: string = 'QUO/{year}/';
  textQuoteHeader: string = '';
  textQuoteFooter: string = '';

  prefixCreditNote: string = 'CRN/{year}/';
  textCreditNoteHeader: string = '';
  textCreditNoteFooter: string = '';

  restockOnDelete: boolean = true;
  requireSerialSelection: boolean = true;
  requireBatchSelection: boolean = true;

  createGatewayOrder: boolean = false;
  allowValidationWithDeferredItems: boolean = false;
}
